import { Link } from "react-router-dom";
import InitializeContext from "context/initialize-context";
import { useContext } from "react";
import { checkPermission } from "utils";

const Comment = () => {
    const enums = useContext(InitializeContext);

    if (!checkPermission(["/api/ticket/list"], enums.permissions))
        return <></>;

    return (
        <button className="tp-7 relative mr-3" title="تیکت ها">
            <Link to="/panel/ticket" className="w-full h-full flex items-center justify-center">
                {/* <span className="badge-c1">4</span> */}
                <i className="fa-regular fa-message"></i>
            </Link>
        </button>
    )
}

export default Comment;